@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  padding-bottom: 10px;
  border-bottom: 1px solid @filter-editor--name--border-color;
  font-size: 14px;
}

.entry-wrapper {
  margin: 10px 0 40px 20px;
  display: flex;
  align-items: center;
}

.input {
  padding-left: 10px;
}
